import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { SesionService } from 'core-tsi';

export const accesoSucursalGuard: CanActivateFn = () => {

  const router = inject(Router)
  const sesion = inject(SesionService)

  const codsuc = sesion.getSucursalSelected()

  if (codsuc && codsuc > 0) {
    return true
  }

  router.navigate(['/seleccionar-sucursal'])
  return false
}
